import { ComponentPropsWithRef, forwardRef, ReactNode } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export type BodyTextProps = ComponentPropsWithRef<'p'> &
  VariantProps<typeof bodyTextVariants> & {
    variant?: 'subtitle' | 'body' | 'caption';
    weight?: 400 | 500 | 700;
    children: ReactNode;
  };

const BodyText = forwardRef<HTMLParagraphElement, BodyTextProps>(
  ({ variant = 'body', weight = 400, className, children, ...props }, ref) => (
    <p ref={ref} className={cn(bodyTextVariants({ variant, weight }), className)} {...props}>
      {children}
    </p>
  )
);

BodyText.displayName = 'BodyText';

const bodyTextVariants = cva('', {
  variants: {
    variant: {
      subtitle: ['text-lg', 'leading-normal'],
      body: ['text-sm', 'leading-comfy'],
      caption: ['text-xs', 'leading-normal'],
    },
    weight: {
      400: 'font-normal',
      500: 'font-medium',
      700: 'font-bold',
    },
  },
});

export default BodyText;
